import { render, staticRenderFns } from "./HeaderForLogin.vue?vue&type=template&id=9ba74e64&scoped=true&lang=pug"
import script from "./HeaderForLogin.vue?vue&type=script&lang=js"
export * from "./HeaderForLogin.vue?vue&type=script&lang=js"
import style0 from "./HeaderForLogin.vue?vue&type=style&index=0&id=9ba74e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba74e64",
  null
  
)

export default component.exports